interface ServiceMainTitle {
  category: string
  title: string
  sub_title: string
  sub_title2: string
  text: string
  imgSrc: string
}

export const serviceMainTitle: ServiceMainTitle = {
  category: 'デジタルPoC',
  title: '特徴量エンジニアリングと生成AI',
  sub_title: '',
  sub_title2: '',
  text: '当社では生成AIに特徴量エンジニアリングを適用したUI生成のR&Dを取り組んでいます。この知見の応用範囲は広く限られたデータで、より期待にそったアウトプットを生成AIからアウトプットさせるPoCプロジェクトが可能です。',
  imgSrc: '/images/img/img_services_feature_engineering.png.png',
}
